module.exports = __webpack_public_path__ + "img/cover_photo.2d3c79a6.jpg";